import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { louiseBotImageUrl } from '@/constants/dashboard-popover-urls.constant';

type BannerHelperProps = {
  message: React.ReactNode;
  imageUrl?: string;
  buttons?: React.ReactNode;
  isReactHtmlParser?: boolean;
};

export const BannerHelper: React.FC<BannerHelperProps> = ({ message, imageUrl = louiseBotImageUrl, buttons, isReactHtmlParser = true }) => {
  return (
    <div className="tw-flex tw-bg-[#d3e3fd] tw-rounded-md tw-px-2 tw-py-2 tw-w-full">
      <div className="tw-flex lg:tw-flex-row tw-flex-col tw-items-center tw-w-full tw-gap-2">
        <div className="tw-flex tw-items-center  tw-gap-2 tw-w-full">
          {imageUrl && (
            <div className="tw-rounded-full tw-w-10 tw-h-10 tw-bg-gray-200 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-ml-2">
              <img src={imageUrl} alt="Toast Icon" className="tw-w-9 tw-h-9 tw-rounded-full" />
            </div>
          )}

          <div className="tw-flex-1 tw-text-sm  tw-font-normal tw-font-['Lexend'] tw-leading-relaxed tw-w-full">
            {isReactHtmlParser && ReactHtmlParser(message)}
            {!isReactHtmlParser && message}
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0 tw-mr-4 tw-justify-end tw-w-full lg:tw-w-auto">{buttons}</div>
      </div>
    </div>
  );
};
